import _CircularProgress from "@material-ui/core/esm/CircularProgress";
import _useMediaQuery from "@material-ui/core/esm/useMediaQuery";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { FooterChat } from "./ChatComponents/FooterChat/FooterChat";
import { MediaMenu } from "./ChatComponents/MediaMenu";
import { SettingsPrivateChat } from "./ChatComponents/SettingsPrivateChat/SettingsPrivateChat";
import { HeaderChat } from "./ChatComponents/HeaderChat";
import Messages from "../Messages/Messages.js";
import { SearchBar } from "./ChatComponents/SearchBar";
import { useStyles } from "./ChatStyles";
import { useChat } from "./hooks/useChat";
import { PreviewFiles } from "./ChatComponents/PreviewFiles";
import { DeleteModal } from "./ChatComponents/DeleteModal";
import { EditModal } from "./ChatComponents/EditModal";
import { useMessenger } from "../Messenger";

var _ref = /*#__PURE__*/_jsx("span", {}, void 0, "No hay un chat seleccionado");

var _ref2 = /*#__PURE__*/_jsx(_CircularProgress, {
  color: "primary"
});

var _ref3 = /*#__PURE__*/_jsx("span", {}, void 0, "No hay mensajes");

const Chat = () => {
  const _useChat = useChat(),
        messages = _useChat.messages,
        pendingMessages = _useChat.pendingMessages;

  const _useState = useState({}),
        _useState2 = _slicedToArray(_useState, 2),
        settingsColors = _useState2[0],
        setSettingColors = _useState2[1];

  const classes = useStyles(settingsColors);
  const theme = useTheme();

  const smDown = _useMediaQuery(theme.breakpoints.down('sm'));

  const _useMessenger = useMessenger(),
        selectedChat = _useMessenger.selectedChat;

  const _useState3 = useState([]),
        _useState4 = _slicedToArray(_useState3, 2),
        filesToSend = _useState4[0],
        setFilesToSend = _useState4[1];

  const _useState5 = useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        showMediaMenu = _useState6[0],
        setShowMediaMenu = _useState6[1];

  const _useState7 = useState(false),
        _useState8 = _slicedToArray(_useState7, 2),
        showSettings = _useState8[0],
        setShowSettings = _useState8[1];

  const _useState9 = useState(false),
        _useState10 = _slicedToArray(_useState9, 2),
        showSearchBar = _useState10[0],
        setShowSearchBar = _useState10[1];

  const _useState11 = useState(),
        _useState12 = _slicedToArray(_useState11, 2),
        selectedMessage = _useState12[0],
        setSelectedMessage = _useState12[1];

  const _useState13 = useState(false),
        _useState14 = _slicedToArray(_useState13, 2),
        visibleDeleteModal = _useState14[0],
        setVisibleDeleteModal = _useState14[1];

  const _useState15 = useState(false),
        _useState16 = _slicedToArray(_useState15, 2),
        visibleEditModal = _useState16[0],
        setVisibleEditModal = _useState16[1];

  const handleDeleteMessage = message => {
    setSelectedMessage(message);
    setVisibleDeleteModal(true);
  };

  const handleEditMessage = message => {
    setSelectedMessage(message);
    setVisibleEditModal(true);
  };

  const changeSettingPrivateChat = objectColors => {
    setSettingColors(objectColors);
    setShowSettings(false);
  };

  const handleAddFileToSend = file => filesToSend.length < 5 && setFilesToSend([...filesToSend, file]);

  if (!smDown && !selectedChat) {
    return _jsx("div", {
      className: classes.noChat
    }, void 0, _ref);
  }

  return _jsx("div", {
    className: "".concat(classes.container, " chatWindow ").concat(selectedChat && 'visible'),
    id: 'chat'
  }, void 0, _jsx(DeleteModal, {
    visible: visibleDeleteModal,
    setVisible: setVisibleDeleteModal,
    message: selectedMessage
  }), _jsx(EditModal, {
    visible: visibleEditModal,
    setVisible: setVisibleEditModal,
    message: selectedMessage
  }), _jsx("div", {
    className: classes.headerChat
  }, void 0, _jsx(HeaderChat, {
    appliedColors: settingsColors,
    searchBar: [showSearchBar, setShowSearchBar],
    settings: [showSettings, setShowSettings],
    selectedChat: selectedChat
  })), showSearchBar && _jsx("div", {
    className: classes.searchBar
  }, void 0, _jsx(SearchBar, {
    showSearchBar: showSearchBar,
    setShowSearchBar: setShowSearchBar,
    appliedColors: settingsColors
  })), _jsx("div", {
    className: classes.bodyChat
  }, void 0, !messages ? _jsx("div", {
    className: classes.loaderContainer
  }, void 0, _ref2) : messages.length || pendingMessages.length ? _jsx(Messages, {
    handleEditMessage: handleEditMessage,
    handleDeleteMessage: handleDeleteMessage,
    selectedChat: selectedChat
  }) : _jsx("div", {
    className: classes.noChat
  }, void 0, _ref3), showMediaMenu && _jsx("div", {
    className: classes.mediaMenu
  }, void 0, _jsx(MediaMenu, {
    showMediaMenu: showMediaMenu,
    setShowMediaMenu: setShowMediaMenu,
    handleAddFileToSend: handleAddFileToSend,
    appliedColors: settingsColors
  }))), !!filesToSend.length && _jsx("div", {
    className: classes.sectionFiles
  }, void 0, _jsx(PreviewFiles, {
    files: filesToSend,
    setFiles: setFilesToSend
  })), _jsx("div", {
    className: classes.footerChat
  }, void 0, _jsx(FooterChat, {
    showMediaMenu: showMediaMenu,
    setShowMediaMenu: setShowMediaMenu,
    appliedColors: settingsColors,
    filesAvailable: filesToSend,
    setFilesAvailable: setFilesToSend
  })), showSettings && _jsx("div", {
    className: classes.settings
  }, void 0, _jsx(SettingsPrivateChat, {
    appliedColors: settingsColors,
    showSettings: showSettings,
    setShowSettings: setShowSettings,
    handleLoadNewTheme: changeSettingPrivateChat
  })));
};

export { Chat };